import { Col, Copyright, Description, Flex, FooterWrapper, Heading, Wrapper } from 'components/theme/Footer/styles';
import { Link } from 'gatsby';
import React from 'react';
import NavbarLinks from '../Header/NavbarLinks';

const icon2 = require('../../../../static/favicon/fav-white.png');

export const Footer = () => (
  <Wrapper>
    <Flex>
      <Col>
        <Heading>Mapa</Heading>

        <div>
          <NavbarLinks desktop footer />
        </div>
      </Col>

      <Col>
        <Heading>Kontakt</Heading>

        <Description>
          <div>
            <a href="mailto:hello@outoffocus.video">hello@outoffocus.video</a>
          </div>
        </Description>
      </Col>

      {/* <Col
        style={{ width: '100%', maxWidth: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
      >
        <img width="70" src={icon2} />
      </Col> */}
    </Flex>

    <FooterWrapper>
      <Copyright>
        <div>
          <span>© {new Date().getFullYear()} All rights reserved</span>{' '}
          <span>
            <Link to="/privacy">Polityka prywatności</Link>
          </span>
        </div>
      </Copyright>

      {/* <LinksWrapper>
        <Links>
          {social.map(({ id, name, link, icon }) => (
            <a key={id} href={link} target="_blank" rel="noopener noreferrer">
              <img width="35" src={icon} alt={name} />
            </a>
          ))}
        </Links>
      </LinksWrapper> */}
    </FooterWrapper>
  </Wrapper>
);
